export default __webpack_public_path__ + "static/media/pt-logo-header.59266bf7.svg";